import { render, staticRenderFns } from "./SingleDiscard.vue?vue&type=template&id=0543eb7a&scoped=true&"
import script from "./SingleDiscard.vue?vue&type=script&lang=js&"
export * from "./SingleDiscard.vue?vue&type=script&lang=js&"
import style0 from "./SingleDiscard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SingleDiscard.vue?vue&type=style&index=1&id=0543eb7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0543eb7a",
  null
  
)

component.options.__file = "SingleDiscard.vue"
export default component.exports